// ARQUIVO ATUALIZADO
import React from 'react';
// --- INÍCIO DA ALTERAÇÃO 1: Importando ícones e hooks ---
import { CloseIcon, CheckIcon, ArchiveIcon, DuplicateIcon, DeleteIcon, SunIcon } from '../ui/Icons';
import GlassButton from '../ui/Button';
import InlineEditor from '../ui/InlineEditor';
import useData from '../../hooks/useData';
// --- FIM DA ALTERAÇÃO 1 ---

const TaskHeader = ({ task, onBack, onComplete, onArchive, onDuplicate, onDelete, onSaveTitle }) => {
    // --- INÍCIO DA ALTERAÇÃO 2: Buscando a função para alterar o status do "Meu Dia" ---
    const { handleToggleMyDay } = useData();
    // --- FIM DA ALTERAÇÃO 2 ---
    
    return (
        <header className="sticky top-0 z-10 bg-gray-800/80 backdrop-blur-sm p-4 sm:p-6 border-b border-white/10 flex-shrink-0">
            <div className="flex justify-between items-center gap-4">
                
                <div className="flex items-center gap-4 flex-1 min-w-0">
                    {/* --- INÍCIO DA ALTERAÇÃO 3: Botão do Meu Dia adicionado ao lado do título --- */}
                    <GlassButton 
                        onClick={() => handleToggleMyDay(task.id, task.isMyDay)}
                        title={task.isMyDay ? "Remover de Meu Dia" : "Adicionar ao Meu Dia"}
                        variant="minimal"
                        className="!p-2"
                    >
                        <SunIcon size={24} className={task.isMyDay ? 'text-yellow-400' : 'text-gray-400'} />
                    </GlassButton>
                    {/* --- FIM DA ALTERAÇÃO 3 --- */}
                    <InlineEditor
                        value={task.title}
                        onSave={onSaveTitle}
                        title="Editar Título da Tarefa"
                    >
                        <h2 className="text-2xl font-bold text-white truncate uppercase" title="Clique para editar o título">
                            {task.title}
                        </h2>
                    </InlineEditor>
                </div>
                
                <div className="flex items-center flex-shrink-0 gap-2">
                    {task.status !== 'Concluído' && (
                        <GlassButton onClick={onComplete} title="Marcar como Conclucluída" variant="minimal" className="!p-2 !bg-green-500/20 hover:!bg-green-500/30">
                            <CheckIcon size={20} className="text-green-300" />
                        </GlassButton>
                    )}
                     <GlassButton onClick={onArchive} title="Arquivar Tarefa" variant="minimal" className="!p-2">
                        <ArchiveIcon size={20} />
                    </GlassButton>
                     <GlassButton onClick={onDuplicate} title="Duplicar Tarefa" variant="minimal" className="!p-2">
                        <DuplicateIcon size={20} />
                    </GlassButton>
                     <GlassButton onClick={onDelete} title="Excluir Tarefa" variant="minimal" className="!p-2 !bg-red-500/20 hover:!bg-red-500/30">
                        <DeleteIcon size={20} className="text-red-400" />
                    </GlassButton>

                    <div className="w-px h-6 bg-white/20 mx-2"></div>
                    
                    <GlassButton onClick={onBack} title="Fechar" className="!p-3">
                        <CloseIcon size={24} />
                    </GlassButton>
                </div>
            </div>
        </header>
    );
}

export default TaskHeader;